// import React, { useEffect } from "react";
// import Input from "../../../form/Input";
// import useForm from "../../../../hooks/useForm";
// import Button from "../../../form/Button";
// import useMutation from "../../../../hooks/useMutation";
// import Editor from "../../../form/Editor";
// import { emailTemplateAddEdit } from "../../../../services/emailService";
// import TinyEditor from "../../../form/TinyEditor";

// const validation = {
//   subject: { required: true, message: "Email subject is required" },
//   content: { required: true, message: "Email content is required" },
//   fromName: { required: true, message: "Sender name is required" },
// };

// const ManageEmailTemplate = ({
//   getResponse = () => {},
//   close = () => {},
//   data,
// }) => {
//   useEffect(() => {
//     if (data?._id) {
//       setFieldsValue(data);
//     }
//   }, [data]);

//   const {
//     values,
//     handleChange,
//     handleSubmit,
//     errors,
//     setFieldsValue,
//     resetField,
//     formValidate,
//   } = useForm({
//     validationRules: validation,
//     initialState: {
//       subject: "",
//       fromName: "",
//       content: "",
//     },
//   });

//   const {
//     mutate,
//     error,
//     isPending: isLoading,
//   } = useMutation({
//     mutationFn: async (val) => {
//       return await emailTemplateAddEdit({
//         ...val,
//         ...(data?._id && { id: data?._id }),
//       });
//     },
//     onSuccess: (res) => {
//       getResponse(res);
//       return res;
//     },
//     onError: (error) => {
//       console.log(error);
//     },
//   });

//   return (
//     <form onSubmit={(event) => handleSubmit(event, mutate)}>
//       <div className="grid grid-cols-12 gap-x-4 gap-y-4">
//         <div className="relative col-span-6">
//           <Input
//             label="Email Subject"
//             inputPlaceholder={"Enter Email Subject"}
//             inputName="subject"
//             value={values?.subject}
//             onChange={handleChange}
//             {...formValidate(errors, "subject")}
//           />
//         </div>
//         <div className="relative col-span-6">
//           <Input
//             label="Sender Name"
//             inputPlaceholder={"Enter Sender Name"}
//             inputName="fromName"
//             value={values?.fromName}
//             onChange={handleChange}
//             {...formValidate(errors, "fromName")}
//           />
//         </div>
//         <div className="relative col-span-12">
//           <TinyEditor
//             label="Email Body"
//             value={values?.content}
//             onChange={(val) => {
//               handleChange({
//                 target: { name: "content", value: val },
//               });
//             }}
//             {...formValidate(errors, "content")}
//           />
//         </div>
//       </div>
//       <div className="relative col-span-4 mt-5">
//         <div className="flex items-center justify-center gap-4">
//           <Button
//             buttonType="submit"
//             buttonLabel={"Save"}
//             buttonClasses={
//               "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
//             }
//             buttonLabelClasses={"mx-auto"}
//             {...(isLoading && {
//               loading: true,
//               buttonIconPosition: "left",
//               isDisable: true,
//             })}
//           />
//           <Button
//             buttonLabel={"Cancel"}
//             buttonClasses={
//               "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
//             }
//             buttonLabelClasses={"mx-auto"}
//             buttonFunction={close}
//           />
//         </div>
//       </div>
//     </form>
//   );
// };

// export default ManageEmailTemplate;

import { useEffect } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import {
  emailDetails,
  emailTemplateAddEdit,
} from "../../../../services/emailService";
import TinyEditor from "../../../form/TinyEditor";
// import { useMutation, useQuery } from "@tanstack/react-query";
import Form from "../../../form/Form";
import Tags from "../../../form/Tags";
import Textarea from "../../../form/Textarea";
import FileUploadSingle from "../../../form/FileUploadSingle";
import Tooltip from "../../../elements/Tooltip";
import useFetch from "../../../../hooks/useFetch";
import useMutation from "../../../../hooks/useMutation";

const validation = {
  name: { required: true, message: "Email content is required" },
  subject: { required: true, message: "Subject is required" },
  to: {
    required: true,
    type: "arrayValidation",
    message: "Recipient email is required",
  },
  fromName: { required: true, message: "Sender name is required" },
  fromEmail: { required: true, message: "Sender email is required" },
};

const ManageEmailTemplate = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: {
      replyTo: [{ name: "", email: "" }],
    },
  });

  const {
    data: details,
    isLoading: detailsLoading,
    isFetching: detailsFetching,
  } = useFetch({
    dependencies: ["email-details", data?._id],
    fetchFunction: async () => {
      const res = await emailDetails({ id: data?._id });
      return res?.data;
    },
    enabled: !!data?._id,
  });

  useEffect(() => {
    if (details?._id) {
      setFieldsValue({
        id: details?._id,
        name: details?.name,
        subject: details?.subject,
        htmlBody: details?.htmlBody,
        // placeholders: details?.placeholders,
        fromName: details?.from?.name,
        fromEmail: details?.from?.email,
        replyTo: details?.replyTo,
        to: details?.recipients?.to?.map((item) => ({
          label: item,
          value: item,
        })),
        cc: details?.recipients?.cc?.map((item) => ({
          label: item,
          value: item,
        })),
        bcc: details?.recipients?.bcc?.map((item) => ({
          label: item,
          value: item,
        })),
        attachments: details?.attachments,
      });
    }
  }, [details]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
        from: { name: val?.fromName, email: val?.fromEmail },
        recipients: {
          to: val?.to?.map((item) => item?.label),
          cc: val?.cc?.map((item) => item?.label),
          bcc: val?.bcc?.map((item) => item?.label),
        },
      };
      delete payload?._id;
      delete payload?.fromName;
      delete payload?.fromEmail;
      delete payload?.to;
      delete payload?.cc;
      delete payload?.bcc;
      return await emailTemplateAddEdit(payload);
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <Form
      handleSubmit={handleSubmit}
      onSubmit={mutate}
      loading={detailsLoading}
      className="p-5 h-[calc(100%-50px)] overflow-hidden"
    >
      <div className="grid grid-cols-12 gap-x-4 gap-y-4 max-h-[calc(100%-80px)] overflow-auto">
        <div className="relative col-span-6">
          <Input
            label="Template Name"
            inputPlaceholder={"Enter template Name"}
            inputName="name"
            value={values?.name}
            onChange={handleChange}
            {...formValidate(errors, "name")}
          />
        </div>
        <div className="relative col-span-6">
          <Input
            label="Sender Name"
            inputPlaceholder={"Enter Sender Name"}
            inputName="fromName"
            value={values?.fromName}
            onChange={handleChange}
            {...formValidate(errors, "fromName")}
          />
        </div>

        <div className="relative col-span-6">
          <Input
            label="Sender Email"
            inputPlaceholder={"Enter Sender Email"}
            inputType="email"
            inputName="fromEmail"
            value={values?.fromEmail}
            onChange={handleChange}
            {...formValidate(errors, "fromEmail")}
          />
        </div>

        <div className="relative col-span-6">
          <Tags
            label="To"
            placeholder={"Enter To Recipients"}
            value={values?.to}
            dropdownData={values?.to}
            onChange={(val) => {
              handleChange({ target: { name: "to", value: val } });
            }}
            {...formValidate(errors, "to")}
          />
        </div>
        <div className="relative col-span-6">
          <Tags
            label="CC"
            placeholder={"Enter CC"}
            value={values?.cc}
            dropdownData={values?.cc}
            onChange={(val) => {
              handleChange({ target: { name: "cc", value: val } });
            }}
            {...formValidate(errors, "cc")}
          />
        </div>
        <div className="relative col-span-6">
          <Tags
            label="BCC"
            placeholder={"Enter BCC"}
            value={values?.bcc}
            dropdownData={values?.bcc}
            onChange={(val) => {
              handleChange({ target: { name: "bcc", value: val } });
            }}
            {...formValidate(errors, "bcc")}
          />
        </div>
        <div className="col-span-12 py-4">
          <FileUploadSingle
            label={"Add attachment"}
            value={values?.attachment}
            onChange={(file) =>
              handleChange({ target: { name: "attachment", value: file } })
            }
          />
        </div>
        <div className="bg-chestnut-rose/20 col-span-12 grid grid-cols-12 gap-4 rounded-lg p-5">
          {values?.replyTo?.map((item, i) => (
            <>
              <div className="relative col-span-6">
                <Input
                  label="Reply To name"
                  inputPlaceholder={"Enter name"}
                  value={item?.name}
                  onChange={(e) => {
                    setFieldsValue({
                      replyTo: values?.replyTo?.map((elm, index) =>
                        index === i
                          ? {
                              ...elm,
                              name: e.target.value,
                            }
                          : elm
                      ),
                    });
                  }}
                />
              </div>
              <div className="relative col-span-6">
                <Input
                  label="Reply To email"
                  inputPlaceholder={"Enter email"}
                  value={item?.email}
                  inputType="email"
                  onChange={(e) => {
                    setFieldsValue({
                      replyTo: values?.replyTo?.map((elm, index) =>
                        index === i
                          ? {
                              ...elm,
                              email: e.target.value,
                            }
                          : elm
                      ),
                    });
                  }}
                />
              </div>
            </>
          ))}
          <div className="col-span-12 flex justify-end">
            <Button
              buttonLabel={"Add more reply to"}
              buttonFunction={() => {
                setFieldsValue({
                  replyTo: [...values?.replyTo, { name: "", email: "" }],
                });
              }}
            />
          </div>
        </div>
        <div className="relative col-span-12">
          <Textarea
            label="Email subject"
            inputPlaceholder={"Enter subject"}
            inputValue={values?.subject}
            inputName={"subject"}
            onChange={handleChange}
            {...formValidate(errors, "subject")}
          />
        </div>
        <div className="relative col-span-12">
          <TinyEditor
            label={
              <div className="flex items-center justify-between">
                <span>Email Body</span>
                {details?.placeholders?.length > 0 && (
                  <span className="text-base h-8 w-8 bg-chestnut-rose rounded-md text-white flex items-center justify-center">
                    <Tooltip
                      message={
                        <ul className="py-3 space-y-1">
                          {details?.placeholders?.map((placeholder, i) => (
                            <li
                              key={i}
                              className="flex items-center gap-1 md:gap-2 text-xs"
                            >
                              <span>{placeholder?.key}:</span>
                              <span>{placeholder?.description}</span>
                            </li>
                          ))}
                        </ul>
                      }
                    >
                      <i className="fa-fw fa-regular fa-info-circle"></i>
                    </Tooltip>
                  </span>
                )}
              </div>
            }
            value={values?.htmlBody}
            onChange={(val) => {
              handleChange({
                target: { name: "htmlBody", value: val },
              });
            }}
            {...formValidate(errors, "htmlBody")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5 h-16">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </Form>
  );
};

export default ManageEmailTemplate;
